import { Transition } from 'react-transition-group';
import { AlertPopupContainer } from '../../../components/alert-popup/alertPopup.styled';
import Button from '../../../components/button';
import Heading from '../../../components/typography';
import { COLORS } from '../../../constants/style/color';

interface FeatureSetDeleteConfirmModalProps {
  isShow: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
  message: string;
  isAssigned?: boolean;
  loading?: boolean;
}

const FeatureSetDeleteConfirmModal = ({
  isShow,
  message,
  isAssigned,
  handleClose,
  handleSubmit,
  loading,
}: FeatureSetDeleteConfirmModalProps): JSX.Element => {
  return (
    <Transition in={isShow} timeout={250}>
      {(state) => (
        <AlertPopupContainer id='deleteFeatureSetModalOverlay'>
          <div className={`modalBackdrop modalBackdrop-${state}`} id='deleteFeatureSetModalContainer'>
            <div className={`sideBar sideBar-${state} `}>
              <div className='popupDialog'>
                <div
                  className='popupContent'
                  id='deleteFeatureSetModalBody'
                  style={
                    isAssigned
                      ? { borderTop: `4px solid ${COLORS.Red}`, background: COLORS.LightRed }
                      : undefined
                  }>
                  {isAssigned && (
                    <div className='flex items-center gap-2 mb-3'>
                      <span
                        className='material-symbols-outlined'
                        style={{ color: COLORS.Red, fontSize: '24px' }}>
                        warning
                      </span>
                      <Heading
                        variant='h6'
                        title='Warning'
                        id='deleteFeatureSetWarningLabel'
                        style={{ color: COLORS.Red, margin: 0 }}
                      />
                    </div>
                  )}
                  <Heading
                    variant='h5'
                    className='mb-5'
                    title={message}
                    id='deleteFeatureSetModalTitle'
                  />

                  <div className='popupButtons'>
                    <Button
                      variant='primary-dark'
                      title='Close'
                      onClick={handleClose}
                      id='deleteFeatureSetModalCancel'
                    />
                    <Button
                      variant={isAssigned ? 'primary-danger' : 'primary'}
                      title='Confirm'
                      onClick={handleSubmit}
                      icon={<span className='material-symbols-outlined'>check_circle</span>}
                      loading={loading}
                      id='deleteFeatureSetModalConfirm'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AlertPopupContainer>
      )}
    </Transition>
  );
};

export default FeatureSetDeleteConfirmModal;
